import { v4 as uuidv4 } from 'uuid';
import getClientConfig from './getClientConfig';

const { enableAvalaraIdentity, enableAvalaraIdentityJwt } = getClientConfig();

export default {

     getScreenDetails()
    {
        return 'width=' + window.screen.width  + '&height=' + window.screen.height + '&scaling-factor=' + window.devicePixelRatio +'&colour-depth=' + window.screen.colorDepth;
    },
    getTimeZone() {
        var offset = new Date().getTimezoneOffset();
        var absOffset = Math.abs(offset);
        return 'UTC' + (offset < 0 ? "+" : "-") + ("00" + Math.floor(absOffset / 60)).slice(-2) + ":" + ("00" + (absOffset % 60)).slice(-2);
    },
     getOS() {
        var OSName = "Unknown";
        if (window.navigator.userAgent.indexOf("Windows NT 10.0") != -1) OSName = "Windows 10";
        if (window.navigator.userAgent.indexOf("Windows NT 6.2") != -1) OSName = "Windows 8";
        if (window.navigator.userAgent.indexOf("Windows NT 6.1") != -1) OSName = "Windows 7";
        if (window.navigator.userAgent.indexOf("Windows NT 6.0") != -1) OSName = "Windows Vista";
        if (window.navigator.userAgent.indexOf("Windows NT 5.1") != -1) OSName = "Windows XP";
        if (window.navigator.userAgent.indexOf("Windows NT 5.0") != -1) OSName = "Windows 2000";
        if (window.navigator.userAgent.indexOf("Mac") != -1) OSName = "Mac/iOS";
        if (window.navigator.userAgent.indexOf("X11") != -1) OSName = "UNIX";
        if (window.navigator.userAgent.indexOf("Linux") != -1) OSName = "Linux";

        return OSName;
    },
    getPlugins()
    {
        var plugins = '';
        var pluginsLength = window.navigator.plugins.length;
        for(var i = 0; i < pluginsLength; i++) {
            if(i > 0)
                plugins += ',';
            plugins += encodeURIComponent(window.navigator.plugins[i].name);
        }
       return plugins;
    },
    getDeviceId()
    {
        if(localStorage.deviceId === undefined)
            localStorage.deviceId = uuidv4();

        return localStorage.deviceId;
    },
    getClientIP()
    {
        return new Promise(function(resolve, reject) {
            try {
                window.RTCPeerConnection = window.RTCPeerConnection || window.mozRTCPeerConnection || window.webkitRTCPeerConnection;   //compatibility for firefox and chrome
                var pc = new RTCPeerConnection({iceServers: []}), noop = function () {
                };
                pc.createDataChannel("");    //create a bogus data channel
                pc.createOffer(pc.setLocalDescription.bind(pc), noop);    // create offer and set local description
                pc.onicecandidate = function (ice) {  //listen for candidate events
                    try {
                        if (!ice || !ice.candidate || !ice.candidate.address ||
                            ice == null || ice.candidate == null || ice.candidate.address == null) resolve('');
                        resolve(ice.candidate.address);
                        pc.onicecandidate = noop;
                    }
                    catch(error)
                    { resolve(''); }
                };
            }
            catch(error)
            { resolve(''); }
        });

    },
    getFraudPreventionHeaders(token)
    {
         var screenDetails= this.getScreenDetails();
         var timeZone = this.getTimeZone();
         var plugins = this.getPlugins();
         var deviceId = this.getDeviceId();
         var promise = this.getClientIP();
            return promise.then((myIP) => {
              return new Promise(function(resolve, reject) {
                const headers = {
                    'Content-Type': 'application/json',
                    'X-CustomHeader':
                    '|ClientScreens:' + screenDetails +
                    '|BrowserJSUserAgent:' + navigator.userAgent +
                    '|ClientWindowSize:' + 'width=' + window.innerWidth + '&height=' + window.innerHeight +
                    '|ClientTimezone:' + timeZone +
                    '|ClientDoNotTrack:' + (window.navigator.doNotTrack === 1 ? true : false) +
                    '|ClientBrowserPlugins:' + plugins +
                    '|ClientLocaIPs:' + encodeURIComponent(myIP) +
                    '|ClientDeviceId:' + deviceId +
                    '|ClientLocaIPsTimestamp:' + (new Date()).toISOString()
                }

                if (!(enableAvalaraIdentity || enableAvalaraIdentityJwt)) {
                    headers.Authorization = token;
                }

                resolve (headers);
            });
        });
    }
}